// extracted by mini-css-extract-plugin
export default {"component":"ShowProvidersSortButton__component--slots-EcFC_"};